import ElAside from './Aside.vue'

/* istanbul ignore next */
ElAside.install = function (app) {
  app.component(ElAside.name, ElAside)
}

export default ElAside
